import type { RootState } from '../store';
import type { Client } from '../common/types/client';
import type { DecryptedItem } from '../common/types/items';

const getClients = (state: RootState): DecryptedItem<Client>[] => state.clients.clients;

const getCurrentClient = (state: RootState): DecryptedItem<Client> | null => state.clients.currentClient;

const getAdvisors = (state: RootState) => {
  const clients = getClients(state);

  return clients.reduce((advisors: string[], client: DecryptedItem<Client>) => {
    const advisor = client.payload.advisor;
    if (advisor == null || advisors.includes(advisor)) {
      return advisors;
    }
    return advisors.concat(advisor);
  }, []);
};

const getStatus = (state: RootState) => state.clients.status;

const clientSelector = {
  getClients,
  getCurrentClient,
  getAdvisors,
  getStatus,
};

export default clientSelector;
